module.exports = __webpack_public_path__ + "img/teams-delete-main-icon.fe6a5fc2.svg";